import { ErrorMessage, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { Form, useNavigate, useParams } from "react-router-dom";
import users from "../../apiConfigs/users";
import { ReactComponent as Seperate } from "../../assets/seperator.svg";
import Button from "../../designComponents/Button";
import Dropdown from "../../designComponents/Dropdown/Dropdown";
import LabelInputField from "../../designComponents/LabelInputField/LabelInputField";
import Loading from "../../designComponents/Loading";
import Typography from "../../designComponents/Typography";
import requestAPI from "../../utils/requestAPI";
import {
  ActiveNavText,
  Card,
  Navigation,
  NavLink,
  NavText,
  Title,
  Wrapper,
} from "../Properties/Details/styles";
import MediaUploader from "../../designComponents/MediaUpload/MediaUpload";

type UserDetailsType = {
  _id: string;
  firstName: string;
  lastName: string;
  email: string;
  countryCode: string;
  phone: string;
  address: string;
  createdAt: string;
  avatar: string;
  role: string[];
};

function EditUser() {
  const [userDetails, setUserDetails] = useState<UserDetailsType | undefined>(
    undefined
  );
  const [loading, setLoading] = useState<boolean>(false);
  const [uploadedFile, setUploadedFile] = useState<File | null | string>(null);
  const { id } = useParams<{ id: string }>(); // Type the params to get the id correctly
  // const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   const file = e.target.files?.[0] || null;
  //   setUploadedFile(file);
  // };

  // const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
  //   const file = e.dataTransfer.files[0];
  // };
  useEffect(() => {
    if (id) {
      setLoading(true);
      const getUserDetails = async (id: string) => {
        try {
          const response = await requestAPI(users.getUserDetails(id));
          setUserDetails(response);
        } catch (error) {
        } finally {
          setLoading(false);
        }
      };

      getUserDetails(id);
    }
  }, [id]);
  useEffect(() => {
    if (userDetails?.role) {
      setSelectedRoles(userDetails?.role[0]);
    }
    if (userDetails?.avatar) {
      setUploadedFile(userDetails?.avatar);
    }
  }, [userDetails?.role]);
  const handleSubmit = async (values: {
    firstName: string;
    lastName: string;
    address: string;
    email: string;
    phoneNumber: string;
    accountStatus: string;
    role: string;
    avatar: File | null;
  }) => {
    try {
      await requestAPI(
        users.updateUser(
          {
            firstName: values.firstName,
            lastName: values.lastName,
            address: values.address,
            email: values.email,
            phone: values.phoneNumber,
            role: selectedRoles,
            avatar: uploadedFile,
          },
          userDetails?._id ?? ""
        )
      );
    } catch (error) {}
  };
  const roleOptions = [
    { label: "Land Lord", value: "LANDLORD" },
    { label: "Operator", value: "OPERATOR" },
    { label: "Customer Support", value: "CUSTOMER_SUPPORT" },
    { label: "Tenant", value: "TENANT" },
  ];
  const navigate = useNavigate();
  const [selectedRoles, setSelectedRoles] = useState("");
  return (
    <Wrapper>
      {loading ? (
        <Loading />
      ) : (
        <>
          {userDetails && (
            <div>
              <Title style={{ paddingBottom: 14 }}>
                {userDetails.firstName} {userDetails.lastName}
              </Title>
              <Navigation
                style={{
                  paddingBottom: 15,
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <NavLink onClick={() => navigate(-1)}>
                  <NavText>Table</NavText>
                </NavLink>
                <Seperate fill="#7E7E7E"></Seperate>
                <ActiveNavText>Edit User</ActiveNavText>
              </Navigation>
              <div>
                <Formik
                  initialValues={{
                    firstName: userDetails.firstName,
                    lastName: userDetails.lastName,
                    email: userDetails.email,
                    phoneNumber: userDetails.phone,
                    address: userDetails.address,
                    // userRole: userDetails.role,
                    accountStatus: "Active",
                  }}
                  onSubmit={(values) => {
                    //@ts-ignore
                    handleSubmit(values);
                  }}
                >
                  {({ setFieldValue, values }) => (
                    <Form style={{ width: "100%", gap: 20 }}>
                      <div style={{ display: "flex", gap: 18 }}>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 18,
                            flex: 1,
                          }}
                        >
                          <div
                            className="add-user-card"
                            style={{
                              backgroundColor: "white",
                              padding: 16,
                              borderRadius: 10,
                              border: "1px solid #F1EFFB",
                            }}
                          >
                            <Typography fontWeight="medium" size={"h3"}>
                              Edit Information
                            </Typography>

                            <div
                              style={{
                                display: "flex",
                                gap: 20,
                                width: "100%",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: 6,
                                  width: "100%",
                                }}
                              >
                                <LabelInputField
                                  onChange={(e) => {
                                    setFieldValue("firstName", e.target.value);
                                  }}
                                  name="firstName"
                                  value={values.firstName}
                                  placeHolder="Type full name eg. Alfonso Crist"
                                  style={{
                                    label: {
                                      fontSize: "14px",
                                      fontWeight: "500",
                                      color: "#555A77",
                                    },
                                    input: {
                                      height: 50,
                                      border: "1px solid #F1EFFB",
                                      padding: 8,
                                      background: "#F1EFFB",
                                      borderRadius: 6,
                                      width: "100%",
                                    },
                                    container: {
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: 6,
                                      paddingTop: 14,
                                      width: "100%",
                                    },
                                  }}
                                  label="First Name"
                                />
                              </div>

                              <LabelInputField
                                onChange={(e) => {
                                  setFieldValue("lastName", e.target.value);
                                }}
                                value={values.lastName}
                                name="lastName"
                                placeHolder="Type full name eg. Alfonso Crist"
                                style={{
                                  label: {
                                    fontSize: "14px",
                                    fontWeight: "500",
                                    color: "#555A77",
                                  },
                                  input: {
                                    height: 50,
                                    border: "1px solid #F1EFFB",
                                    padding: 8,
                                    background: "#F1EFFB",
                                    width: "100%",
                                    borderRadius: 6,
                                  },
                                  container: {
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 6,
                                    paddingTop: 14,
                                    width: "100%",
                                  },
                                }}
                                label="Last Name"
                              />
                            </div>

                            <LabelInputField
                              name="email"
                              onChange={(e) => {
                                setFieldValue("email", e.target.value);
                              }}
                              value={values.email}
                              placeHolder="Type valid email eg. Alfonso.Crist09@gmail.com"
                              style={{
                                label: {
                                  fontSize: "14px",
                                  fontWeight: "500px",
                                  color: "#555A77",
                                },
                                input: {
                                  height: 50,
                                  border: "1px solid #F1EFFB",
                                  padding: 8,
                                  background: "#F1EFFB",
                                  borderRadius: 6,
                                  width: "100%",
                                },
                                container: {
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: 6,
                                  paddingTop: 14,
                                },
                              }}
                              label="Email"
                            />
                            <div style={{ paddingTop: 10 }}></div>
                          </div>

                          <div
                            className="add-user-card"
                            style={{
                              backgroundColor: "white",
                              padding: 16,
                              borderRadius: 10,
                              border: "1px solid #F1EFFB",
                            }}
                          >
                            <Typography fontWeight="medium" size={"h3"}>
                              Edit Personal Information
                            </Typography>

                            <LabelInputField
                              name="phoneNumber"
                              onChange={(e) => {
                                setFieldValue("phoneNumber", e.target.value);
                              }}
                              value={values.phoneNumber}
                              placeHolder="Type Phone Number eg. (933) 999999999"
                              style={{
                                label: {
                                  fontSize: "14px",
                                  fontWeight: "500px",
                                  color: "#555A77",
                                },
                                input: {
                                  height: 50,
                                  border: "1px solid #F1EFFB",
                                  padding: 8,
                                  background: "#F1EFFB",
                                  borderRadius: 6,
                                  width: "100%",
                                },
                                container: {
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: 6,
                                  paddingTop: 14,
                                },
                              }}
                              label="Phone Number"
                            />
                            <div style={{ paddingTop: 10 }}></div>
                            <LabelInputField
                              name="address"
                              value={values.address}
                              onChange={(e) => {
                                setFieldValue("address", e.target.value);
                              }}
                              placeHolder="Type valid Address eg. Dublin 2, Temple Bar, County Dublin"
                              style={{
                                label: {
                                  fontSize: "14px",
                                  fontWeight: "500px",
                                  color: "#555A77",
                                },
                                input: {
                                  height: 50,
                                  border: "1px solid #F1EFFB",
                                  padding: 8,
                                  background: "#F1EFFB",
                                  borderRadius: 6,
                                  width: "100%",
                                },
                                container: {
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: 6,
                                  paddingTop: 14,
                                },
                              }}
                              label="Address"
                            />
                            <div style={{ paddingTop: 10 }}></div>
                            {/* <MediaUploader
                              image={userDetails?.avatar}
                              label="Profile Picture"
                              onChange={(e) => {
                                const file = e.target.files?.[0] || null;
                                setUploadedFile(file);
                              }}
                              onDrop={handleDrop}
                              style={{
                                container: { paddingTop: 10, gap: 6 },
                                label: { paddingBottom: 10, color: "#555A77" },
                                dropzone: { background: "#F1EFFB" },
                              }}
                            ></MediaUploader> */}
                          </div>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 26,
                          }}
                        >
                          <div
                            style={{
                              width: 400,
                              height: 160,
                              background: "white",
                              borderRadius: 6,
                              padding: 10,
                              border: "1px solid #F1EFFB",
                            }}
                          >
                            <Typography fontWeight="medium" size={"h3"}>
                              User Role
                            </Typography>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 26,
                              }}
                            >
                              <Dropdown
                                options={roleOptions}
                                label="Select admin Role"
                                value={selectedRoles}
                                style={{
                                  container: { paddingTop: 10 },
                                  label: {
                                    paddingBottom: 6,
                                    color: "#555A77",
                                  },
                                  select: {
                                    backgroundColor: "#F1EFFB",
                                    fontSize: 14,
                                    fontFamily: "urbanist",
                                    fontWeight: 500,
                                    padding: "8px",
                                  },
                                }}
                                onChange={(e) => {
                                  setSelectedRoles(e.target.value);
                                }}
                              ></Dropdown>

                              <div style={{ paddingTop: 10 }}>
                                <ErrorMessage
                                  name="userRole"
                                  component="div"
                                  //@ts-ignore

                                  style={{ color: "red" }}
                                />
                              </div>
                            </div>
                          </div>
                          <Card style={{ margin: 0 }}>
                            <MediaUploader
                              onChange={(e) => {
                                const file = e.target.files?.[0] || null;
                                setUploadedFile(file);
                              }}
                              image={
                                userDetails.avatar ? [userDetails.avatar] : []
                              }
                              style={{
                                container: { paddingTop: 10, gap: 6 },
                                label: { paddingBottom: 10, color: "#555A77" },
                                dropzone: { background: "#F1EFFB" },
                              }}
                            ></MediaUploader>
                          </Card>
                        </div>
                      </div>

                      <div style={{ paddingTop: 20 }}>
                        <Button
                          style={{
                            backgroundColor: "#725ED4",
                            borderRadius: 8,
                            color: "white",
                          }}
                          onClick={() => {
                            //@ts-ignore
                            handleSubmit(values);
                            console.log(values);
                          }}
                        >
                          Submit
                        </Button>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          )}
          {!userDetails && !loading && <p>No user found.</p>}
        </>
      )}
    </Wrapper>
  );
}

export default EditUser;
